import axios, { AxiosResponse } from "axios";
import { TableData } from "../../models/dtos/base/TableData";
import { SupporterTicketInsertDTO } from "../../models/dtos/supporter/SupportTicketInsertDTO";
import { SupportTicketRowDTO } from "../../models/dtos/supporter/SupportTicketRowDTO";
import { DepartmentTypes } from "../../models/interfaces/management/DepartmentType";
import { SupportTicketQueryString } from "../../models/query-strings/managment/SupportTicketQueryString";
import BaseService from "../base/BaseService";

export default class TicketCenterService extends BaseService {
    getPaged(query: SupportTicketQueryString): Promise<TableData<SupportTicketRowDTO>> {
        return axios.get(`/SupportTickets`, { params: query })
            .then(function (response: AxiosResponse<TableData<SupportTicketRowDTO>, any>) {
                return response.data;
            });
    }

    getDepartmentIdByDepartmentType(query: DepartmentTypes):Promise<number>{
        return axios.get(`/SupportDepartmentRoles/Type/${query}`)
        .then(function (response: AxiosResponse<number>) {
            return response.data;
        });
    }

    createTicket(dto: SupporterTicketInsertDTO):Promise<any>{
        return axios.post(`/SupportTickets/PersonalTicket`, dto)
        .then(function (response: AxiosResponse<any>) {
            return response.data;
        });
    }
}